import { clearCache, getOrInitCachedState } from './cache';
import { EVENTS, STATES } from './constants';
import { chatTriggeredEvent } from './bi';
import { isLoggedIn } from './utils';
import Forethought from './Forethought';
import { logger } from './logger';
import { getForethoughtConfig } from './api';

export function validateEvent(detail, cachedState = {}) {
    if (!detail) {
        throw new Error(
            '"detail" payload is not defined for event. Please, fire event like new CustomEvent("supportchat:init", { detail: { ...your properties } })'
        );
    }
    if (!detail.tags) {
        throw new Error('Missing param "tags" needed to initiate support chat');
    }

    const state = detail.state || cachedState.state;

    if (!state) {
        throw new Error('Missing param "state" needed to initiate support chat');
    }
    if (state && !Object.values(STATES).find((stateItem) => stateItem === state)) {
        throw new Error(`"state" property has to have one of these values: ${Object.values(STATES).toString()}`);
    }
    if (detail.createdAt && !(detail.createdAt instanceof Date)) {
        throw new Error('"createdAt" param has to be of type Date');
    }
}

function mergeCachedAndEventStates(eventState, cachedState = {}) {
    return {
        tags: eventState.tags ? [...(cachedState.tags ? cachedState.tags : []), ...eventState.tags] : cachedState.tags,
        state: eventState.state || cachedState.state,
        createdAt: eventState.createdAt || cachedState.createdAt,
        enableForGuests: eventState.enableForGuests,
    };
}

export async function handleChatInit(ev) {
    if (!ev.detail) {
        throw new Error('"detail" payload is not defined for event');
    }

    const { tags, state, createdAt } = ev.detail;

    if (!isLoggedIn()) {
        clearCache();

        return;
    }

    const cachedState = getOrInitCachedState();

    validateEvent(ev.detail, cachedState);

    const tagsWithUserType = [...tags, `user_type-${window.dataLayer && window.dataLayer[0].user_type}`];
    const eventState = { tags: tagsWithUserType, state, createdAt };

    chatTriggeredEvent(tagsWithUserType);

    const mergedState = mergeCachedAndEventStates(eventState, cachedState);

    try {
        const forethoughtConfig = await getForethoughtConfig();
        const stateWithConfig = { ...mergedState, forethoughtConfig };

        logger.debug('[Event Handler] Initializing Forethought with config:', forethoughtConfig);
        new Forethought(stateWithConfig);
    } catch (error) {
        logger.error('[Event Handler] Failed to initialize Forethought:', error);
    }
}

export const initEventListeners = () => {
    window.addEventListener(EVENTS.INIT_CHAT, handleChatInit);
};
